





















import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { ErrorManager } from '@/models/error';
import { TimeOffTypeFieldError } from '@/models';

export default Vue.extend({
  name: 'TimeOffTypePicker',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: [Number, Object, Array],

    externalErrorMessage: {
      type: [Array, Object] as PropType<string[] | TimeOffTypeFieldError>,
      default: () => []
    }
  },

  data() {
    return {
      lazyValue: this.value,
      search: '',
      errorMessage: '',
      loading: false
    };
  },

  watch: {
    value: {
      handler(val: any) {
        this.lazyValue = val;
      },
      immediate: true
    }
  },

  computed: {
    ...mapGetters({
      timeOffTypes: 'timeOff/getTimeOffTypes'
    }),

    internalValue: {
      get(): any {
        return this.lazyValue;
      },
      set(val: any) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },

    customAttrs(): object {
      return this.$attrs;
    },

    errorMessageList(): string[] {
      let errorList: string[] = [];

      if (!(this.externalErrorMessage instanceof TimeOffTypeFieldError)) {
        errorList = this.externalErrorMessage;
      }
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    }
  },

  mounted() {
    // fetch all timeOffTypes
    this.loading = true;

    this.fetchTimeOffTypes()
      .catch(error => {
        this.errorMessage = ErrorManager.extractApiError(error);
      })
      .finally(() => (this.loading = false));
  },

  methods: {
    ...mapActions({
      fetchTimeOffTypes: 'timeOff/fetchTimeOffTypes'
    })
  }
});
